import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import FormActions from "components/FormActions";
import hoverable from "components/hoc/hoverable";

import styles from "./EditableTitle.css";

export class EditableTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: props.title,
      isEdit: props.isEdit,
    };

    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  static getDerivedStateFromProps({ title }, state) {
    if (!state.isEdit && state.title !== title) return { title };

    return null;
  }

  handleEdit() {
    this.setState({ isEdit: true });
  }

  handleChange(evt) {
    this.setState({ title: evt.target.value });
  }

  handleCancel() {
    this.setState({ title: this.props.title, isEdit: false });
  }

  handleUpdate() {
    this.props.onUpdate(this.state.title);
    this.setState({ isEdit: false });
  }

  render() {
    const { isEdit, title } = this.state;
    const { isHovered } = this.props;

    return (
      <div
        className={cx(styles.root, {
          [styles.hovered]: isHovered,
          [styles.edit]: isEdit,
        })}
      >
        {isEdit ? <input onChange={this.handleChange} type="text" value={title} /> : title}
        <div className={styles.editActions}>
          <FormActions
            isEdit={isEdit}
            onCancel={() => this.handleCancel()}
            onEdit={() => this.handleEdit()}
            onSave={this.handleUpdate}
            isHovered
            withIcon
          />
        </div>
      </div>
    );
  }
}

EditableTitle.propTypes = {
  isEdit: PropTypes.bool,
  isHovered: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default hoverable(EditableTitle);
